import { NavigationContainerRef } from "@react-navigation/native";
import React from "react";

export const isReadyRef = React.createRef();

export const navigationRef = React.createRef<NavigationContainerRef>();

export function navigate(name: string, params?: Object) {
  if (isReadyRef.current && navigationRef.current) {
    // Perform navigation if the app has mounted
    navigationRef.current.navigate(name, params);
  }
}
